import { Modal } from 'bootstrap.native';

export class Cart {
    /**
    * Dynamic handling of cart actions
    * @param {HTMLElement} element Cart
    */
    constructor (element) {
        // Name, reference
        element.Cart = this;

        // Elements
        this._refs = {
            buttons: {
                emptycart: element.querySelector('.js-cart-empty'),
                emptycartIcon: element.querySelector('.empty-basket-icon')
            },
            dialog: element.querySelector('.js-cart-dialog'),
            favorites: element.querySelector('.favorites'),
            pageControls: element.querySelector('.page-controls'),
            cartMainTitle: document.querySelector('.top-main-title'),
            removeFavourite: element.querySelectorAll('.js-cartline-remove'),
            cartLineConfig: element.querySelectorAll('.cart-line__configuration')
        };

        const productsTextSingular = document.getElementById('cssCart')?.getAttribute('cart-title-overwrite-text-singular');
        const productsTextPlural = document.getElementById('cssCart')?.getAttribute('cart-title-overwrite-text-plural');
        const productsAmount = document.getElementById('cssCart')?.getAttribute('cart-title-overwrite-counter');

        // Properites
        this._props = {
            manager: window.Sys.WebForms.PageRequestManager.getInstance()
        };

        // Events
        if(this._refs.buttons.emptycart != null) {
            this._refs.buttons.emptycart.addEventListener('click', this._onEmptyCartClick.bind(this));
        }

        if (this._refs.buttons.emptycartIcon != null) {
            this._refs.buttons.emptycartIcon.addEventListener('click', this._onEmptyCartClick.bind(this));
        }

        // Updatepanel - callback event attachments
        if (typeof this._props.manager !== "undefined" && this._props.manager !== null) {
            this._props.manager.add_endRequest((sender, e) => {
                this._onCartLoyaltyValidationError();
            });
        }

        if (this._refs.cartMainTitle && productsAmount && productsTextSingular && productsTextPlural) {
            this._refs.cartMainTitle.textContent = `${this._refs.cartMainTitle.textContent} (${productsAmount} ${parseInt(productsAmount) > 1 ? productsTextPlural : productsTextSingular})`;
        }

        this._removeColumnForEmptyCart();
        this._disableEnterOnPromoField();
        this._removeQuantityIsOneItemAdded();
        this._removeProductBrandsIfEmpty();
    }

    _removeProductBrandsIfEmpty() {
        const productBrands = document.querySelectorAll(".product_brand");

        productBrands.forEach((productBrand) => {
        if (productBrand.innerText.trim() === "") {
            productBrand.parentNode.removeChild(productBrand);
        }
        });
    }

    // If the quantity = 1 for a bundled product (.number-input__field is disabled) remove the quantity field
    _removeQuantityIsOneItemAdded() {
        Array.from(
          document.querySelectorAll(".accessory-type-container")
        ).forEach((node) => {
          const quantity = +node.querySelector(
            ".configurator__accessory-quantity .number-input__field"
          ).value;
          if (quantity === 1 && node.querySelector(".number-input__field:disabled")) {
            node.removeChild(
              node.querySelector(".configurator__accessory-quantity")
                .parentElement
            );
          }
        });
    }

    _removeColumnForEmptyCart() {
        const alert = document.querySelectorAll(".left-summary-container .alert-info");
        const container = document.querySelector(".left-summary-container");
        const rightContainer = document.querySelector(".right-summary-container");
        // Check if the alert exists but also if the right side container is empty
        // Some scenarios show the alert but can have products in cart 
        // so the right side container wont be populated / will be empty of children
        if (Boolean(alert?.length) && !rightContainer.children.length) {
            container.classList.remove("col-md-8");
        }
    }

    // Click 'Enter' on keyboard after entering a Promo code and make it click Promo Submit button
    _disableEnterOnPromoField() {
        let promoTextField = document.querySelector('.promo-code-text');
        let promoSubmit = document.querySelector('.apply-promo-button input');
        if (promoTextField) {
            promoTextField.addEventListener('keypress', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    promoSubmit.click();
                }
            });
        }
    }

    /**
     * Validation to ensure user has enough flexpoints for purchase
     **/
    _onCartLoyaltyValidationError() {
        const oElement = document.querySelector('#dialogInsufficientFlexpoint');

        if (oElement === null) return false;

        const
            oModel = new Modal('#dialogInsufficientFlexpoint'),
            oCheckbox = oElement.querySelector('input[type="checkbox"]'),
            oCancel = oElement.querySelector('.btn-secondary'),
            oContinue = oElement.querySelector('.btn-primary');

        oModel.show();

        if (oCheckbox !== null) {
            oCheckbox.addEventListener('change', (e) => {
                if (e.target.checked) {
                    oContinue.classList.remove('is-disabled');
                } else {
                    oContinue.classList.add('is-disabled');
                }
            });
        }

        oContinue.addEventListener('click', (e) => {
            if (oCheckbox !== null && oCheckbox.checked) {
                return true;
            }
            e.preventDefault();
            return false;
        });

        oCancel.addEventListener('click', (e) => {
            if (oCheckbox !== null && oCheckbox.checked) {
                oCheckbox.checked = false;
                oCheckbox.removeAttr('checked');
            }
        });
    }

    /**
     * oNEmptyCartClick
     * Empty cart and reload page
     * @param {Event} e - Event interface
     */
    _onEmptyCartClick (e) {
        e.preventDefault();

        let
            modal = this._refs.dialog.Modal || new Modal(this._refs.dialog),
            handler = () => {
                modal.hide();
                __doPostBack(this._refs.buttons.emptycart.getAttribute('name') , '');
            };

        // Display modal
        modal.show();

        // Events
        if(this._refs.dialog) {
            this._refs.dialog.addEventListener('shown.bs.modal', (event) => {
                let x = event.target,
                    trigger = x.querySelector('.btn-primary');

               trigger.addEventListener('click', handler);
            }, false);

            this._refs.dialog.addEventListener('hide.bs.modal', (event) => {
                let x = event.target,
                    trigger = x.querySelector('.btn-primary');

                trigger.removeEventListener('click', handler);
            }, false);
        }
    }
}